import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

interface InfoContainerProps {
  opacity: number
}

const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Wrapper = styled(Flex)`
  height: 100vh;
`
export const SwiperPanel = styled(Flex)`
  position: relative;
  height: 100vh;
  width: 50%;
  overflow: hidden;
  background: ${theme.colors.neutral.lighthover};

  .swiper-horizontal {
    width: 100%;
  }

  .swiper-slide {
    height: 100vh;
  }

  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.md};
  }

  .swiper-pagination-bullet {
    opacity: 1;
    width: 16px;
    height: 16px;
    background: ${theme.colors.neutral.white};
  }

  .swiper-pagination-bullet-active {
    width: 24px;
    height: 24px;
    background: ${theme.colors.secondary};
  }

  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 75px;

    @media (max-width: ${theme.breakpoints.lg}px) {
      bottom: 78px;
    }
  }

  @media (max-width: 1115px) {
    display: none;
  }

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 52%;
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    display: none;
  }
`

export const FormPanel = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 50%;
  background: ${theme.colors.quartenary};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 48%;
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    width: 100%;
  }
`

export const Logo = styled.img`
  margin-bottom: ${theme.spacing['2xl']};

  @media (max-width: ${theme.breakpoints.xl}px) and (max-height: 890px) {
    margin-bottom: ${theme.spacing.lg};
  }
`

export const ImageGradient = styled.div`
  position: relative;
  ::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 75.61%);
  }
`

export const SwiperImage = styled.img`
  width: 100%;
  height: 100vh;
  object-fit: cover;
`
export const InfoContainer = styled(Flex)<InfoContainerProps>`
  position: absolute;
  flex-direction: column;
  bottom: 149px;
  padding: 0 105px;
  gap: ${theme.spacing.xm};
  transition: opacity 0.2s ease;
  z-index: 20;
  opacity: ${({ opacity }) => opacity};
  pointer-events: none;

  @media (max-width: ${theme.breakpoints.lg}px) {
    padding: 0 ${theme.spacing.lg};
    bottom: 152px;
  }
`
export const InfoTitle = styled.h1`
  margin: 0;
  text-align: center;
  line-height: ${theme.typography.lineHeight.md};
  font-size: ${theme.typography.sizes.xl};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.white};
`

export const InfoDescription = styled.p`
  margin: 0;
  text-align: center;
  line-height: ${theme.typography.lineHeight.md};
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.white};
`
